package com.arena_web.ui.sections.events

import androidx.compose.runtime.Composable
import com.arena_web.ui.localization.LocalAppStrings
import com.arena_web.ui.theme.AppColors
import com.arena_web.ui.theme.AppTypography
import com.arena_web.ui.theme.LocalSportColors
import com.arena_web.ui.theme.bodyLMedium
import com.arena_web.ui.utils.sBorderRadius
import com.arena_web.ui.utils.sFontSize
import com.arena_web.ui.utils.sGap
import com.arena_web.ui.utils.sHeight
import com.arena_web.ui.utils.sLetterSpacing
import com.arena_web.ui.utils.sLineHeight
import com.arena_web.ui.utils.sMaxWidth
import com.arena_web.ui.utils.sPadding
import com.varabyte.kobweb.compose.css.Cursor
import com.varabyte.kobweb.compose.css.TextAlign
import com.varabyte.kobweb.compose.foundation.layout.Box
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.backgroundColor
import com.varabyte.kobweb.compose.ui.modifiers.color
import com.varabyte.kobweb.compose.ui.modifiers.cursor
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxSize
import com.varabyte.kobweb.compose.ui.modifiers.fontFamily
import com.varabyte.kobweb.compose.ui.modifiers.fontWeight
import com.varabyte.kobweb.compose.ui.modifiers.onClick
import com.varabyte.kobweb.compose.ui.modifiers.textAlign
import com.varabyte.kobweb.silk.components.text.SpanText

@Composable
fun EventsEmptyState(
    onAddEvent: () -> Unit,
    mobile: Boolean = false,
) {
    val sportColors = LocalSportColors.current
    val t = LocalAppStrings.current
    Box(
        modifier = Modifier.fillMaxSize().sPadding(24),
        contentAlignment = Alignment.Center,
    ) {
        Column(
            modifier = Modifier.sGap(if (mobile) 16 else 24),
            horizontalAlignment = Alignment.CenterHorizontally,
        ) {
            SpanText(
                t.arenaEmptyTitle,
                modifier = Modifier
                    .sFontSize(if (mobile) 22 else 32)
                    .fontWeight(AppTypography.SemiBold)
                    .sLineHeight(if (mobile) 26 else 38)
                    .sLetterSpacing(if (mobile) 0.44 else 0.64)
                    .fontFamily(AppTypography.PRIMARY_FONT_NAME, AppTypography.PRIMARY_FONT_FALLBACK)
                    .color(org.jetbrains.compose.web.css.Color("var(--l-text-strong, #BED6F5)")) // dark: over photo; light: over washed backdrop
                    .textAlign(TextAlign.Center),
            )

            SpanText(
                t.arenaEmptySubtitle,
                modifier = Modifier
                    .sMaxWidth(if (mobile) 320 else 720)
                    .sFontSize(if (mobile) 14 else 20)
                    .fontWeight(AppTypography.Medium)
                    .sLineHeight(if (mobile) 20 else 26)
                    .sLetterSpacing(if (mobile) 0.14 else 0.2)
                    .fontFamily(AppTypography.PRIMARY_FONT_NAME, AppTypography.PRIMARY_FONT_FALLBACK)
                    .color(org.jetbrains.compose.web.css.Color("var(--l-text-strong, #BED6F5)")) // dark: over photo; light: over washed backdrop
                    .textAlign(TextAlign.Center),
            )

            Box(
                modifier = Modifier
                    .sHeight(44)
                    .sBorderRadius(22)
                    .sPadding(10, 24)
                    .backgroundColor(sportColors.primary)
                    .cursor(Cursor.Pointer)
                    .onClick { onAddEvent() },
                contentAlignment = Alignment.Center,
            ) {
                SpanText(
                    t.arenaAddEvent,
                    modifier = Modifier
                        .bodyLMedium()
                        .color(sportColors.onPrimary),
                )
            }
        }
    }
}
